import { render, staticRenderFns } from "./OperatorJourneysCountReport.vue?vue&type=template&id=283f2e98&"
import script from "./OperatorJourneysCountReport.vue?vue&type=script&lang=js&"
export * from "./OperatorJourneysCountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports